import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { CommercialStructureListService } from '../../service/commercial-structure-list/commercial-structure-list.service';

@Component({
	selector: 'app-commercial-structure-list',
	templateUrl: './commercial-structure-list.component.html',
	providers: [
		CommercialStructureListService,
		HttpModule
	]
})
export class CommercialStructureListComponent implements OnInit {
	private token;
	public commercialStrucutres: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	commercialStrucutre: FormGroup;

	constructor(fb: FormBuilder, private commercialStructureListService: CommercialStructureListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.commercialStrucutre = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchCommercialStrucutre(this.commercialStrucutre.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchCommercialStrucutre(this.commercialStrucutre.value, this.currentPage, false);
	}

	searchCommercialStrucutre(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.commercialStructureListService.searchCommercialStrucutre(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.commercialStrucutres = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchCommercialStrucutre(this.commercialStrucutre.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/commercial-structure/component/commercial-structure-list/commercial-structure-list.component.ts